import {
    // FILE_UPLOAD,
    CREATE_SERVICEUSERS,
    RETRIEVE_SERVICEUSERS,
    RETRIEVESINGLE_SERVICEUSERS,
    UPDATE_SERVICEUSERS,
    DELETE_SERVICEUSERS,
} from "./type";
import ServiceUsers from "../service/ServiceUsers";
export const create = (data) => async (dispatch) => {
    try {
        const res = await ServiceUsers.create(data);
        dispatch({
            type: CREATE_SERVICEUSERS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ServiceUsers.fetchList(data);
        dispatch({
            type: RETRIEVE_SERVICEUSERS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveStats = (data) => async (dispatch) => {
    try {
        const res = await ServiceUsers.fetchStats(data);
        // dispatch({
        //     type: RETRIEVE_EMPLOYEE,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ServiceUsers.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_SERVICEUSERS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ServiceUsers.update(data);
        dispatch({
            type: UPDATE_SERVICEUSERS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ServiceUsers.changeStatus(data);
//         dispatch({
//             type: UPDATE_SERVICEUSERS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ServiceUsers.trash(data);
        dispatch({
            type: DELETE_SERVICEUSERS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};